(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
  const breadcrumb = document.querySelector(".product-breadcrumbs-wrapper");
  if (!breadcrumb) return;

  const fadeEnabled = breadcrumb.dataset.fadeEffect === "true";
  const fadeThreshold = parseInt(breadcrumb.dataset.fadeThreshold || "80");

  if (!fadeEnabled) return;

  window.addEventListener("scroll", () => {
    const scrollTop = window.scrollY;
    const opacity = Math.max(0, 1 - scrollTop / fadeThreshold);
    const scale = Math.max(0.9, 1 - scrollTop / (fadeThreshold * 10));

    breadcrumb.style.opacity = opacity;
    breadcrumb.style.transform = `scale(${scale})`;
    breadcrumb.style.transition = "opacity 0.2s ease, transform 0.2s ease";
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    // Video hover autoplay functionality – now triggers on whole product card
  (function() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initVideoHover);
    } else {
      initVideoHover();
    }

    function initVideoHover() {
      const galleries = document.querySelectorAll('.card-gallery.has-video-media');
      
      galleries.forEach(gallery => {
        const overlay = gallery.querySelector('.card-gallery__video-overlay');
        if (!overlay) return;
        
        const video = overlay.querySelector('video');
        if (!video) return;

        video.muted = true;
        video.playsInline = true;
        video.loop = true;

        // Find the outer product card container
        const productCard = gallery.closest('.product-grid__item, product-card');
        if (!productCard) return; // fallback to gallery if not found

        // Desktop hover – still on gallery (media area only)
        gallery.addEventListener('mouseenter', () => {
          if (window.matchMedia('(hover: hover)').matches) {
            video.currentTime = 0;
            video.play().catch(e => console.log('Video play failed:', e));
          }
        });

        gallery.addEventListener('mouseleave', () => {
          if (window.matchMedia('(hover: hover)').matches) {
            video.pause();
            video.currentTime = 0;
          }
        });

        // Touch events – now on the whole product card
        productCard.addEventListener('touchstart', () => {
          video.currentTime = 0;
          video.play().catch(e => console.log('Video play failed:', e));
          productCard.classList.add('video-playing');
        }, { passive: true });

        productCard.addEventListener('touchend', () => {
          video.pause();
          video.currentTime = 0;
          productCard.classList.remove('video-playing');
        });

        productCard.addEventListener('touchcancel', () => {
          video.pause();
          video.currentTime = 0;
          productCard.classList.remove('video-playing');
        });
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    class FreeShippingBar {
  constructor(element) {
    this.barElement = element;
    if (!this.barElement) return;

    this.threshold = parseInt(this.barElement.dataset.threshold);
    this.context = this.barElement.dataset.context || 'cart-drawer';
    this.messageTemplate = this.barElement.querySelector('.free-shipping-bar__message-text')?.dataset.message || "Add --amount-- more for free shipping!";
    this.successTemplate = this.barElement.querySelector('.free-shipping-bar__message-text')?.dataset.success || "🎉 You've earned free shipping!";
    this.init();
    this.setupEventListeners();
  }

  init() {
    this.updateBar();
  }

  setupEventListeners() {
    // Listen for cart updates from various sources
    document.addEventListener('cart:updated', (event) => {
      this.handleCartUpdate(event.detail);
    });

    // Listen for Shopify's native cart events
    document.addEventListener('shopify:section:load', () => {
      setTimeout(() => this.updateBar(), 500);
    });

    // Listen for AJAX cart events
    document.addEventListener('ajax:add-to-cart:success', () => {
      setTimeout(() => this.updateBar(), 800);
    });

    document.addEventListener('ajax:add-to-cart:error', () => {
      setTimeout(() => this.updateBar(), 800);
    });

    // ========== NEW: CART REMOVAL EVENTS ==========
    document.addEventListener('ajax:cart:item-removed', () => {
      setTimeout(() => this.updateBar(), 600);
    });

    document.addEventListener('cart:item-removed', () => {
      setTimeout(() => this.updateBar(), 600);
    });

    // Listen for quantity changes
    document.addEventListener('change', (event) => {
      if (event.target && (event.target.classList.contains('cart-quantity') || 
          event.target.name === 'quantity')) {
        setTimeout(() => this.updateBar(), 800);
      }
    });

    // Listen for custom events from product forms
    document.addEventListener('product:added', () => {
      setTimeout(() => this.updateBar(), 1000);
    });

    // Listen for cart drawer events
    if (this.context === 'cart-drawer') {
      document.addEventListener('cart-drawer:opened', () => {
        setTimeout(() => this.updateBar(), 100);
      });

      document.addEventListener('cart-drawer:updated', () => {
        setTimeout(() => this.updateBar(), 300);
      });
    }

    // ========== PRODUCT PAGE SPECIFIC EVENTS ==========
    if (this.context === 'product-page') {
      this.setupProductPageListeners();
      this.setupPollingFallback();
      this.setupCartIconObserver(); // NEW: Watch cart count changes
    }
  }

  setupProductPageListeners() {
    // Listen for all ATC button clicks
    document.addEventListener('click', (event) => {
      const atcButton = event.target.closest('[name="add"], [data-add-to-cart], .add-to-cart, .product-form__submit');
      if (atcButton) {
        setTimeout(() => this.updateBar(), 1500);
      }
    });

    // Listen for form submissions
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (form && form.closest('form[action*="/cart/add"]')) {
        setTimeout(() => this.updateBar(), 2000);
      }
    });

    // Listen for cart drawer events
    document.addEventListener('cart-drawer:opened', () => {
      setTimeout(() => this.updateBar(), 500);
    });

    // Listen for visibility changes
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        setTimeout(() => this.updateBar(), 300);
      }
    });
  }

  setupPollingFallback() {
    let pollInterval = null;
    let pollTimeout = null;

    document.addEventListener('click', (event) => {
      const atcButton = event.target.closest('[name="add"], [data-add-to-cart], .add-to-cart, .product-form__submit');
      if (atcButton) {
        this.startPolling();
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (form && form.closest('form[action*="/cart/add"]')) {
        this.startPolling();
      }
    });
  }

  startPolling() {
    if (this.pollInterval) clearInterval(this.pollInterval);
    if (this.pollTimeout) clearTimeout(this.pollTimeout);

    let pollCount = 0;
    const maxPolls = 5;
    
    this.pollInterval = setInterval(() => {
      this.updateBar();
      pollCount++;
      
      if (pollCount >= maxPolls) {
        clearInterval(this.pollInterval);
      }
    }, 2000);

    this.pollTimeout = setTimeout(() => {
      if (this.pollInterval) clearInterval(this.pollInterval);
    }, 11000);
  }

  // ========== NEW METHOD: CART ICON OBSERVER ==========
  setupCartIconObserver() {
    let lastCartCount = this.getCurrentCartCount();
    
    setInterval(() => {
      const currentCartCount = this.getCurrentCartCount();
      if (currentCartCount !== lastCartCount) {
        console.log('Cart count changed - updating shipping bar');
        lastCartCount = currentCartCount;
        this.updateBar();
      }
    }, 1000);
  }

  // ========== NEW METHOD: GET CURRENT CART COUNT ==========
  getCurrentCartCount() {
    const cartCountSelectors = [
      '.cart-count',
      '[data-cart-count]',
      '.cart-bubble',
      '.cart-icon__count'
    ];

    for (const selector of cartCountSelectors) {
      const element = document.querySelector(selector);
      if (element) {
        const count = element.textContent.trim();
        const match = count.match(/\d+/);
        if (match) return parseInt(match[0]);
      }
    }
    
    try {
      if (window.Shopify && window.Shopify.cart && window.Shopify.cart.item_count !== undefined) {
        return window.Shopify.cart.item_count;
      }
    } catch (e) {}
    
    return -1;
  }

  async updateBar() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.calculateTotal(cart.items, cart.cart_level_discount_applications);
    } catch (error) {
      console.error('Error updating free shipping bar:', error);
    }
  }

  calculateTotal(items, discounts = []) {
    let total = 0;
    let hasShippableItems = false;

    items.forEach(item => {
      if (item.requires_shipping) {
        total += item.final_line_price;
        hasShippableItems = true;
      }
    });

    discounts.forEach(discount => {
      total -= discount.total_allocated_amount;
    });

    total = Math.max(0, total);
    this.updateDisplay(total, hasShippableItems);
  }

  // ========== UPDATED METHOD: HANDLE EMPTY CART ==========
  updateDisplay(total, hasShippableItems) {
    // For product page, always show regardless of shippable items or empty cart
    if (this.context === 'product-page') {
      this.barElement.style.display = 'block';
      
      // Handle empty cart scenario specifically
      if (total === 0) {
        // Reset to initial state - 0% progress, show full threshold
        this.updateProgressBar(0);
        this.updateEmptyCartMessage();
        return; // Skip the normal update logic
      }
    } 
    // For cart drawer, only show if there are shippable items
    else if (!hasShippableItems || this.threshold <= 0) {
      this.barElement.style.display = 'none';
      return;
    } else {
      this.barElement.style.display = 'block';
    }
    
    const progressPercentage = Math.min((total / this.threshold) * 100, 100);
    const amountRemaining = this.threshold - total;
    
    this.updateProgressBar(progressPercentage);
    this.updateMessage(progressPercentage, amountRemaining);
  }

  // ========== NEW METHOD: EMPTY CART MESSAGE ==========
  updateEmptyCartMessage() {
    const messageElement = this.barElement.querySelector('.free-shipping-bar__message-text');
    const messageContainer = this.barElement.querySelector('.free-shipping-bar__message');
    const iconElement = this.barElement.querySelector('.free-shipping-bar__icon');
    
    if (!messageElement) return;

    // Remove all state classes
    this.barElement.classList.remove('free-shipping-bar--reached', 'free-shipping-bar--close', 'free-shipping-bar--urgent');
    
    // Show empty cart message with full threshold
    const fullThreshold = this.formatMoney(this.threshold);
    const animatedAmount = `<span class="free-shipping-bar__amount" data-remaining-amount="${this.threshold}">${fullThreshold}</span>`;
    const message = `Add ${animatedAmount} more for <strong>free shipping</strong>!`;
    messageElement.innerHTML = message;

    
    // Reset message styling
    if (messageContainer) {
      messageContainer.classList.remove('free-shipping-bar__message--success');
    }
    if (iconElement) {
      iconElement.style.display = 'none';
    }
  }

  updateProgressBar(percentage) {
    const fillElement = this.barElement.querySelector('.free-shipping-bar__fill');
    if (fillElement) {
      fillElement.style.width = `${percentage}%`;
    }

    if (percentage >= 100) {
      this.barElement.classList.add('free-shipping-bar--reached');
      this.barElement.classList.remove('free-shipping-bar--close', 'free-shipping-bar--urgent');
    } else {
      this.barElement.classList.remove('free-shipping-bar--reached');
    }
  }

  updateMessage(percentage, amountRemaining) {
    const messageElement = this.barElement.querySelector('.free-shipping-bar__message-text');
    const messageContainer = this.barElement.querySelector('.free-shipping-bar__message');
    const iconElement = this.barElement.querySelector('.free-shipping-bar__icon');
    
    if (!messageElement) return;

    // Get message templates from data attributes (Liquid side)
    let messageTemplate = messageElement.dataset.message || "Add --amount-- more for free shipping!";
    let successTemplate = messageElement.dataset.success || "🎉 You've earned free shipping!";

    if (percentage >= 100) {
      // Success message
      let successMessage = successTemplate.replace(/(free shipping)/gi, '<b>$1</b>');
      messageElement.innerHTML = `<b>${successMessage}</b>`;
      if (messageContainer) messageContainer.classList.add('free-shipping-bar__message--success');
      if (iconElement) iconElement.style.display = 'block';
    } else {
      // In-progress message
      const formattedAmount = this.formatMoney(amountRemaining);
      const animatedAmount = `<span class="free-shipping-bar__amount" data-remaining-amount="${amountRemaining}">${formattedAmount}</span>`;
      
      let message = messageTemplate.replace('--amount--', animatedAmount);
      message = message.replace(/(free shipping)/gi, '<b>$1</b>');
      
      messageElement.innerHTML = message;
      if (messageContainer) messageContainer.classList.remove('free-shipping-bar__message--success');
      if (iconElement) iconElement.style.display = 'none';

      this.updateUrgencyClasses(amountRemaining);
    }
  }

  updateUrgencyClasses(amountRemaining) {
    this.barElement.classList.remove('free-shipping-bar--close', 'free-shipping-bar--urgent');
    
    if (amountRemaining <= 2000 && amountRemaining > 0) {
      this.barElement.classList.add('free-shipping-bar--close');
    }
    if (amountRemaining <= 500 && amountRemaining > 0) {
      this.barElement.classList.add('free-shipping-bar--urgent');
    }
  }

  formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.money_format);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  handleCartUpdate(cartData) {
    if (cartData && cartData.items) {
      this.calculateTotal(cartData.items, cartData.cart_level_discount_applications);
    } else {
      this.updateBar();
    }
  }
}

// === Initialize only once per element ===
function initFreeShippingBars() {
  document.querySelectorAll('[data-free-shipping-bar]').forEach(element => {
    if (!element.freeShippingInstance) {
      element.freeShippingInstance = new FreeShippingBar(element);
    } else {
      // Just update existing instance instead of recreating
      element.freeShippingInstance.updateBar();
    }
  });
}

// Initial load
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(initFreeShippingBars, 500);
});

// Re-run when cart drawer opens or updates
['cart-drawer:opened', 'cart-drawer:updated'].forEach(evt => {
  document.addEventListener(evt, () => setTimeout(initFreeShippingBars, 200));
});

// Manual trigger available globally
window.updateFreeShippingBar = initFreeShippingBars;
  } catch(e) { console.error(e); }
})();

})();
